/**
 * AuthorAvatar — tiny circular avatar that prefers an uploaded image and falls back to initials.
 *
 * Props: name, avatarUrl, size (px), bg (initials background color)
 */
export default function AuthorAvatar({ name, avatarUrl, size = 28, bg = "#27272A", rounded = true }) {
  const src = avatarUrl?.startsWith("/api/")
    ? `${process.env.REACT_APP_BACKEND_URL}${avatarUrl}`
    : avatarUrl;
  const cls = `${rounded ? "rounded-full" : ""} overflow-hidden flex items-center justify-center font-display text-white shrink-0`;
  if (src) {
    return (
      <div className={cls} style={{ width: size, height: size, background: bg }}>
        <img src={src} alt="" className="w-full h-full object-cover" />
      </div>
    );
  }
  return (
    <div className={cls} style={{ width: size, height: size, background: bg, fontWeight: 900, fontSize: size * 0.42 }}>
      {name?.[0]?.toUpperCase() || "?"}
    </div>
  );
}
